const GET_CONCRETE_BATCHES_REQUEST = 'GET_CONCRETE_BATCHES_REQUEST';
const GET_CONCRETE_BATCHES_SUCCESS = 'GET_CONCRETE_BATCHES_SUCCESS';
const GET_CONCRETE_BATCHES_ERROR = 'GET_CONCRETE_BATCHES_ERROR';

const DELETE_CONCRETE_BATCH_REQUEST = 'DELETE_CONCRETE_BATCH_REQUEST';
const DELETE_CONCRETE_BATCH_SUCCESS = 'DELETE_CONCRETE_BATCH_SUCCESS';
const DELETE_CONCRETE_BATCH_ERROR = 'DELETE_CONCRETE_BATCH_ERROR';

const CREATE_CONCRETE_BATCH_REQUEST = 'CREATE_CONCRETE_BATCH_REQUEST';
const CREATE_CONCRETE_BATCH_SUCCESS = 'CREATE_CONCRETE_BATCH_SUCCESS';
const CREATE_CONCRETE_BATCH_ERROR = 'CREATE_CONCRETE_BATCH_ERROR';

export {
  GET_CONCRETE_BATCHES_REQUEST,
  GET_CONCRETE_BATCHES_SUCCESS,
  GET_CONCRETE_BATCHES_ERROR,
  DELETE_CONCRETE_BATCH_REQUEST,
  DELETE_CONCRETE_BATCH_SUCCESS,
  DELETE_CONCRETE_BATCH_ERROR,
  CREATE_CONCRETE_BATCH_REQUEST,
  CREATE_CONCRETE_BATCH_SUCCESS,
  CREATE_CONCRETE_BATCH_ERROR,
};
